// extracted by mini-css-extract-plugin
export var articleInfoContainer = "bt_fj";
export var articleInfoItem = "bt_fk";
export var itemChild = "bt_fl";